import { IInvoice, IPaymentLink, IProduct } from '../api/Radom'

const qaTimestamp = '2026-04-21T00:00:00.000Z'
const sellerAddress = '0x1111111111111111111111111111111111111111'

const launchPlan: IProduct = {
  id: 'qa-product-launch-plan',
  name: 'Launch plan',
  description: 'One-time onboarding and payment setup package.',
  chargingIntervalSeconds: 0,
  currency: 'GBP',
  price: 100,
  createdAt: new Date(qaTimestamp),
  imageUrl: '',
  updatedAt: new Date(qaTimestamp),
  sellerAddress
}

const prioritySupport: IProduct = {
  id: 'qa-product-priority-support',
  name: 'Priority support',
  description: 'Monthly priority support for merchant operations.',
  chargingIntervalSeconds: 2592000,
  currency: 'GBP',
  price: 49,
  createdAt: new Date(qaTimestamp),
  imageUrl: '',
  updatedAt: new Date(qaTimestamp),
  sellerAddress
}

const platformAccess: IProduct = {
  id: 'qa-product-platform-access',
  name: 'Platform access',
  description: 'Annual platform access for payment operations.',
  chargingIntervalSeconds: 0,
  currency: 'GBP',
  price: 1200,
  createdAt: new Date(qaTimestamp),
  imageUrl: '',
  updatedAt: new Date(qaTimestamp),
  sellerAddress
}

export const previewPaymentLink: IPaymentLink = {
  id: 'qa-payment-link-preview',
  url: '/payment_link/qa-payment-link-preview',
  products: [launchPlan, prioritySupport],
  gateway: {
    managed: {
      methods: [
        { network: 'Ethereum' },
        { network: 'Base' },
        { network: 'Ethereum', token: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48' },
        { network: 'Base', token: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913' },
        { network: 'Solana', token: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v' }
      ]
    }
  },
  customizations: {
    leftPanelColor: 'rgba(0,0,0,1)',
    primaryButtonColor: '#0a2540',
    slantedEdge: false,
    allowDiscountCodes: true,
    allowFreeInputAmount: false
  },
  sellerAddress,
  sellerLogoUrl: '',
  sellerName: 'Radom QA Studio',
  createdAt: new Date(qaTimestamp),
  updatedAt: new Date(qaTimestamp),
  inputFields: [],
  chargeCustomerNetworkFee: true,
  successUrl: 'https://radom.com/checkout/success'
}

export const previewInvoice: IInvoice = {
  id: 'qa-invoice-preview',
  sellerAddress,
  seller: {
    id: 'qa-seller',
    email: 'support@radom.example',
    name: 'Radom QA Studio'
  },
  gateway: previewPaymentLink.gateway,
  customer: {
    id: 'qa-customer-northstar',
    email: 'finance@northstar.example',
    name: 'Northstar Supply Co.',
    billingAddress: '120 Moorgate, London EC2M 6UR, United Kingdom',
    residenceCountry: 'GB',
    companyName: 'Northstar Supply Co.'
  },
  products: [{ product: platformAccess, quantity: 1 }],
  lineItems: [
    {
      invoiceId: '',
      name: 'Implementation workshop',
      quantity: 1,
      price: 450,
      currency: 'GBP'
    },
    {
      invoiceId: '',
      name: 'Priority support credit',
      quantity: 2,
      price: 125,
      currency: 'GBP'
    }
  ],
  issuedAt: new Date(qaTimestamp),
  overdueAt: new Date('2026-05-05T00:00:00.000Z'),
  inputData: [],
  status: 'pending',
  memo: 'Thanks for choosing Radom. This QA invoice includes a saved customer, product, line items, and several accepted payment methods.'
}
